import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Switch, notification, Upload } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { addARecord, editARecord, fetchARecord } from 'Redux/MasterReducer/crudSlices';
import { FormModesEnum, asyncStatuses } from 'Redux/enums';
import { LoadingOutlined, UploadOutlined } from "@ant-design/icons"
import TextArea from 'antd/es/input/TextArea';

const PromotionAddEditForm = ({ apiUrl }) => {
  const [notificationApi, contextHolder] = notification.useNotification();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [promotionImageUrl, setPromotionImageUrl] = useState('');
  const [fileList, setFileList] = useState([]);
  const [removeList, setRemoveList] = useState([]);

  const openNotification = (message, description, type) => {
    notificationApi[type]({
      message: message,
      description: description,
      placement: "top"
    });
  };

  const currentFormMode = useSelector(store => store.master?.currentFormMode);
  const currentEditViewFormId = useSelector(store => store.master?.currentEditViewFormId);
  const fetchRecordStatus = useSelector(store => store.master?.fetchRecordStatus);
  const editRecordStatus = useSelector(store => store.master?.editRecordStatus);
  const addRecordStatus = useSelector(store => store.master?.addRecordStatus);
  const currentRecordData = useSelector(store => store.master?.currentRecordData);

  useEffect(() => {
    if (editRecordStatus === asyncStatuses.SUCCESS) {
      form.resetFields();
    } else if (addRecordStatus === asyncStatuses.SUCCESS) {
      form.resetFields();
    }
    return form.resetFields();
  }, [editRecordStatus, addRecordStatus, form]);

  useEffect(() => {
    form.setFieldsValue(currentRecordData);
    setPromotionImageUrl(currentRecordData.image);
    let currentFiles = currentRecordData?.promotion_files?.map((promfile) => {
      return { uid: promfile.id, name: promfile.file_name }
    })
    setFileList(currentFiles);
  }, [fetchRecordStatus, currentRecordData]);

  useEffect(() => {
    if (currentEditViewFormId && (currentFormMode === FormModesEnum.EDIT || currentFormMode === FormModesEnum.VIEW)) {
      if (!currentEditViewFormId) {
        openNotification("Something went wrong", "Please contact developers. Id was not provided while changing modes", "error");
        return;
      } else {
        dispatch(fetchARecord({ apiUrl: apiUrl, id: currentEditViewFormId }));
      }
    } else {
      form.resetFields();
    }
  }, [currentEditViewFormId, currentFormMode, dispatch]);

  const addNew = (val) => {
    dispatch(addARecord({ apiUrl: apiUrl, data: val, headers: { "Content-Type": "multipart/form-data" } }));
  }

  const edit = (val) => {
    dispatch(editARecord({ apiUrl, id: currentEditViewFormId, data: val, headers: { "Content-Type": "multipart/form-data" } }));
  }

  const onFinish = (val) => {
    if (val['image']['fileList']) {
      let currentAuthorImage = val['image']['fileList'][0]['originFileObj']
      val['image'] = currentAuthorImage;
    }
    const formData = new FormData();
    Object.keys(val).forEach((key) => {
      if (!key.startsWith('upload_files')) {
        formData.append(key, val[key]);
      }
    });
    if (removeList.length > 0) {
      formData.append('remove_files', removeList);
    }
    fileList.forEach((file) => {
      formData.append('promotion_files', file);
    });
    if (currentFormMode === FormModesEnum.ADD) {
      addNew(formData);
    } else if (currentFormMode === FormModesEnum.EDIT) {
      edit(formData);
    } else {
      console.log("No suitable mode found");
    }
  }

  const promotionImageBeforeUpload = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setPromotionImageUrl(reader.result);
    };
    return false;
  };

  const promotionFilesBeforeUpload = (file) => {
    const isLessThan2MB = file.size / 1024 / 1024 < 2;
    if (!isLessThan2MB) {
      openNotification("File too large!", "File must be smaller than 2MB!", "error");
      return Upload.LIST_IGNORE;
    }
    return false;
  };

  const handleChange = ({ fileList }) => {
    console.log(fileList)
    let theseFiles = []
    for (let i = 0; i < fileList.length; i++) {
      if (fileList[i]['originFileObj']) {
        theseFiles.push(fileList[i]['originFileObj']);
      } else {
        theseFiles.push(fileList[i]);
      }
    }
    setFileList(theseFiles);
  };

  const handleRemove = (file) => {
    setRemoveList([...removeList, file.uid]);
    setFileList((prevList) => prevList.filter((item) => item.uid !== file.uid));
  };

  return (
    <>
      {contextHolder}
      <Form layout="vertical"
        requiredMark={true}
        onFinish={onFinish}
        autoComplete="off"
        form={form}
        disabled={currentFormMode === FormModesEnum.VIEW}
      >
        <Form.Item name="title" label="Title"
          rules={[
            {
              required: true,
              message: 'Please enter title',
            },
          ]}
        >
          <Input placeholder="Enter title" />
        </Form.Item>
        <Form.Item name="description" label="Description">
          <TextArea rows={4} placeholder="Enter Description" />
        </Form.Item>
        {/* <Form.Item name="meta_title" label="Meta Title">
          <Input placeholder="Enter Meta Title" />
        </Form.Item>
        <Form.Item name="meta_description" label="Meta Description">
          <TextArea rows={4} placeholder="Enter Meta Description" />
        </Form.Item> */}
        <Form.Item name="is_visible" label="Is Visible">
          <Switch />
        </Form.Item>
        <Form.Item name="image" label="Promotion Image">
          <Upload
            beforeUpload={promotionImageBeforeUpload}
            showUploadList={false}
          >
            {promotionImageUrl ? (
              <img src={promotionImageUrl} alt="blog" style={{ maxWidth: '100%', maxHeight: '200px' }} />
            ) : (
              <Button icon={<UploadOutlined />}>Upload Image</Button>
            )}
          </Upload>
        </Form.Item>
        <Form.Item name="upload_files" label="Promotion Files">
          <Upload
            fileList={fileList}
            beforeUpload={promotionFilesBeforeUpload}
            multiple
            showUploadList={true}
            onChange={handleChange}
            onRemove={handleRemove}
          >
            <Button icon={<UploadOutlined />}>Upload Files</Button>
          </Upload>
        </Form.Item>

        {
          currentFormMode === FormModesEnum.ADD ? <Form.Item>
            {
              addRecordStatus === asyncStatuses.LOADING ?
                <Button type="primary" htmlType="submit" disabled>
                  <LoadingOutlined />
                  Submitting
                </Button> :
                <Button type="primary" htmlType="submit" >
                  Submit
                </Button>
            }
          </Form.Item> : currentFormMode === FormModesEnum.EDIT ? <Form.Item>
            {
              editRecordStatus === asyncStatuses.LOADING ?
                <Button type="primary" htmlType="submit" disabled>
                  <LoadingOutlined />
                  Updating
                </Button> :
                <Button type="primary" htmlType="submit" >
                  Update
                </Button>
            }
          </Form.Item> : <></>
        }

      </Form >
    </>
  );
};
export default PromotionAddEditForm;